"use strict";function goBack$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.goBack$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.navigation.goBack";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.6.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.6.0"},_a)),exports.goBack$=goBack$,exports.default=goBack$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/navigation/goBack.js
// module id = 970
// module chunks = 106